export const ROUTES = {
  AUTH: {
    FORGOTPASSWORD: '/forgot-password',
    LOGIN: '/login',
    VERIFYACCOUNT: '/verify-account',
    RESETPASSWORD: '/reset-password',
  },
  SIDEBAR: {
    DASHBOARD: '/dashboard',
    TRANSACTIONS: '/transactions',
    BULKTRANSACTIONS: '/transactions/bulk',
    PAYOUTS: '/payout',
    SETTLEMENT: '/settlements',
    REQUESTPAYOUT: '/request-payout',
    PAYMENTLINKS: '/payment-links',
    CUSTOMERS: '/customers',
    TEAMMEMBERS: '/team-members',
    PROFILE: '/profile',
    APISETTINGS: '/api-settings',
    DOCUMENTATION: '/docs',
    HELPANDSUPPORT: '/help-support',
  },
  ADMIN: {
    SIDEBAR: {
      OVERVIEW: '/admin/overview',
      ALLTRANSACTIONS: '/admin/transactions',
      CHARGEBACKS: '/admin/chargebacks',
      PAYOUTS: '/admin/payouts',
      SETTLEMENTS: '/admin/settlements',
      CURRENCY: '/admin/countries',
      NEWREQUESTS: '/admin/new-requests',
      ALLMERCHANTS: '/admin/merchants',
      TEAMMEMBERS: '/admin/team-members',
      PERMISSIONS: '/admin/permissions',
    },
  },
}
